import BaseUi from '../baseUi';
import PlayerUIInterface from './playerUIInterface';
import eControllerTypes from '../../controllers/player/eControllerTypes';
import {
  ControllerAutoPlayButton, ControllerBalance, ControllerBet, ControllerBetSelect, ControllerBetSelectorTable,
  ControllerInfo, ControllerMenu, ControllerSound, ControllerSpin, ControllerFullScreen, ControllerTournamentsLabel, ControllerWin, ControllerTurboPlay
} from '../../controllers';
import ControllerAutoPlayTable from '../../controllers/player/ControllerAutoPlayTable';
import ControllerFreebetsPanel from '../../controllers/player/ControllerFreebetsPanel';

export default class BasePlayerUi extends BaseUi {
  constructor(props) {
    super(props);

    this._config = {
      init_controls: true,
      ...this._config,
    };

    this._eControllersClasses = {
      [this.controllerTypes.ECT_BALANCE]: ControllerBalance,
      [this.controllerTypes.ECT_BET]: ControllerBet,
      [this.controllerTypes.ECT_WIN]: ControllerWin,
      [this.controllerTypes.ECT_INFO]: ControllerInfo,
      [this.controllerTypes.ECT_MENU]: ControllerMenu,
      [this.controllerTypes.ECT_FULL_SCREEN]: ControllerFullScreen,
      // [this.controllerTypes.ECT_TOTAL_WIN]: ControllerTotalWin,
      [this.controllerTypes.ECT_SPIN]: ControllerSpin,
      [this.controllerTypes.ECT_AUTO_SPIN]: ControllerAutoPlayButton,
      [this.controllerTypes.ECT_TURBO_SPIN]: ControllerTurboPlay,
      // [this.controllerTypes.ECT_LABEL]: ControllerLabel,
      [this.controllerTypes.ECT_SOUND]: ControllerSound,
      [this.controllerTypes.ECT_BET_SELECT]: ControllerBetSelect,
      [this.controllerTypes.ECT_BET_SELECTOR_TABLE]: ControllerBetSelectorTable,
      [this.controllerTypes.ECT_TOURNAMENTS_LABEL]: ControllerTournamentsLabel,
      // [this.controllerTypes.ECT_INFO_PANEL]: ControllerInfoPanel,
      [this.controllerTypes.ECT_FREEBETS_PANEL]: ControllerFreebetsPanel,
      // [this.controllerTypes.ECT_INFO_PANEL_CLOCK]: ControllerClock,
      // [this.controllerTypes.ECT_AUTO_SPIN_COUNT]: ControllerAutoPlayCount,
      // [this.controllerTypes.ECT_WIN_LINE_LABEL]: ControllerWinLineLabel,
      [this.controllerTypes.ECT_AUTO_PLAY_TABLE]: ControllerAutoPlayTable,
    };
    this._constantControllerTypes = new Set([this.controllerTypes.ECT_TOURNAMENTS_LABEL, this.controllerTypes.ECT_FREEBETS_PANEL]);

    this.onChangeFreeBets = this.onChangeFreeBets.bind(this);
    this.onChangeAutoPlay = this.onChangeAutoPlay.bind(this);

    this._lastFreespinsInfo = null;
  }

  _checkConfig() {
    if (!this._config.init_controls) {

      const types = Object.values(this.controllerTypes);
      for (const type of types) {
        if (!this._constantControllerTypes.has(type)) this._excludedControllerTypes.add(type)
      }

      this._getMarkup = this._getConstantMarkup;
      document.body.classList.add('_ui-no-controls');
      return;
    } else {
      document.body.classList.remove('_ui-no-controls');
    }

    if (this._partnerConfig.disableAutoplay) {
      this._excludedControllerTypes.add(this.controllerTypes.ECT_AUTO_SPIN)
      this._excludedControllerTypes.add(this.controllerTypes.ECT_TURBO_SPIN)
    }
  }

  _addExtraControllersListeners() {
    const betsSelectController = this.controllers[this.controllerTypes.ECT_BET_SELECT];
    const spinController = this.controllers[this.controllerTypes.ECT_SPIN];
    const autoSpinController = this.controllers[this.controllerTypes.ECT_AUTO_SPIN];
    const betsTableController = this.controllers[this.controllerTypes.ECT_BET_SELECTOR_TABLE];
    const autoPlayTableController = this.controllers[this.controllerTypes.ECT_AUTO_PLAY_TABLE];
    const tournamentsLabelController = this.controllers[this.controllerTypes.ECT_TOURNAMENTS_LABEL];
    // const honestyController = this.controllers[this.controllerTypes.ECT_HONESTY];
    const freeBetController = window.OPWrapperService.freeBetsController;
    const events = this.events;

    if (autoSpinController) {
      freeBetController.onChange.add(this.onChangeFreeBets);
    }

    if (betsSelectController) {
      betsSelectController.on(events[this.controllerTypes.ECT_BET_SELECT].SHOW_BETS_CLICK, () => {
        if (betsTableController) betsTableController.show();
        if (autoSpinController && autoPlayTableController) {
          autoPlayTableController.hide();
          autoSpinController.toggleActive(false);
        }
      });

      betsSelectController.on(events[this.controllerTypes.ECT_BET_SELECT].HIDE_BETS_CLICK, () => {
        if (betsTableController) betsTableController.hide();
      });
    }
    if (betsTableController) {
      betsTableController.on(events[this.controllerTypes.ECT_BET_SELECTOR_TABLE].CLOSE_CLICK, () => {
        if (betsSelectController) betsSelectController.reset();
      });
    }
    if (autoSpinController && autoPlayTableController) {
      autoSpinController.on(events[this.controllerTypes.ECT_AUTO_SPIN].AUTO_SPIN_CLICK, () => {
        if (window.OPWrapperService.autoPlay.active) {
          window.OPWrapperService.autoPlay.active = false;
          return;
        }

        const visible = autoPlayTableController.toggle();
        if (betsTableController && visible) {
          betsSelectController.reset();
          betsTableController.hide();
        }
      });

      autoSpinController.toggleActive(window.OPWrapperService.autoPlay.active);
      window.OPWrapperService.autoPlay.onChange.add(this.onChangeAutoPlay);
    }
  }

  onChangeFreeBets() {
    const freeBetController = window.OPWrapperService.freeBetsController;
    const autoSpinController = this.controllers[this.controllerTypes.ECT_AUTO_SPIN];
    if (freeBetController.isLastFreeBet) autoSpinController.toggleActive(false);
  }

  onChangeAutoPlay() {
    const autoSpinController = this.controllers[this.controllerTypes.ECT_AUTO_SPIN];
    const spinController = this.controllers[this.controllerTypes.ECT_SPIN];

    autoSpinController.toggleActive(window.OPWrapperService.autoPlay.active);
    if (window.OPWrapperService.autoPlay.active) {
      const displayData = this._lastFreespinsInfo ? this._lastFreespinsInfo : { count: isFinite(window.OPWrapperService.autoPlay.remainingCount) ? window.OPWrapperService.autoPlay.remainingCount : '∞', text: '' };
      spinController.showFreespins(displayData.count, displayData.text);
    } else if (this._lastFreespinsInfo) { // in case quick spin toggled inside freespins/bonus game
      spinController.showFreespins(this._lastFreespinsInfo.count, this._lastFreespinsInfo.text);
    }  else {
      spinController.hideFreespins();
    }
  }

  blackOut() {
    this.root.classList.add('blacked-out');
  }

  removeBlackOut() {
    this.root.classList.remove('blacked-out');
  }

  _beforeRemove() {
    super._beforeRemove();
    window.OPWrapperService.freeBetsController.onChange.remove(this.onChangeFreeBets);
    window.OPWrapperService.autoPlay.onChange.remove(this.onChangeAutoPlay);
  }

  _afterControllersInit() {
    this._addExtraControllersListeners();

    if (!window.OPWrapperService.model.data.tournamentsInfo || (!window.OPWrapperService.model.data.tournamentsInfo.active.length && !window.OPWrapperService.model.data.tournamentsInfo.future.some(details => !!details.showAnnouncement))) {
      this.controllers[this.controllerTypes.ECT_TOURNAMENTS_LABEL].hide();
    }
    // this._topMainTextsControllers = [
    //   this.controllers[this.controllerTypes.ECT_LABEL],
    //   this.controllers[this.controllerTypes.ECT_WIN],
    // ]
    // this._bottomMainTextsControllers = [
    //   this.controllers[this.controllerTypes.ECT_TOTAL_WIN],
    //   this.controllers[this.controllerTypes.ECT_AUTO_SPIN_COUNT],
    //   this.controllers[this.controllerTypes.ECT_WIN_LINE_LABEL],
    // ]
  }

  _initInterface() {
    return new PlayerUIInterface(this);
  }

  _setupRoot() {
    this.root.setAttribute('id', 'root-ui');
    this.root.classList.add('ui-container');
    if (this._config.blacked_out) {
      this.blackOut();
    }

    this.safeZone = document.createElement('div');
    this.safeZone.classList.add('ui-container__safe_zone');
    this.root.appendChild(this.safeZone);
  }

  _createInterfaceContainer() {
    const interfaceContainer = document.createElement('div');
    interfaceContainer.setAttribute('id', 'player-interface-container');
    this.safeZone.append(interfaceContainer);
    return interfaceContainer;
  }

  // get topMainTextsControllers() {
  //   return this._topMainTextsControllers;
  // }
  //
  // get bottomMainTextsControllers() {
  //   return this._bottomMainTextsControllers;
  // }

  get controllersIdPrefix() {
    return 'player_ui';
  }

  get controllerTypes() {
    return eControllerTypes;
  }

  set scaleData(data) {
    const ScaleManager = window.OPWrapperService.ScaleManager;
    this._scaleData = data;
    const scale = this._scaleData.scale;
    const uiScale = this._scaleData.uiScale;
    const uiScaleRelativeToCanvasScale = this._scaleData.uiScaleRelativeToCanvasScale;

    for (const key in this.controllers) {
      const controller = this.controllers[key];
      controller.scaleData = { scaleData: this._scaleData, rootScale: uiScale };
    }

    //repeating the behavior of the canvas and its stage
    const marginX = (ScaleManager.safeZone.left + this._scaleData.stageX / scale) / uiScaleRelativeToCanvasScale;
    const marginY = (ScaleManager.safeZone.top + this._scaleData.stageY / scale) / uiScaleRelativeToCanvasScale;

    this.safeZone.style.marginRight = `${marginX / ScaleManager.defaultFontSize}rem`;
    this.safeZone.style.marginLeft = `${marginX / ScaleManager.defaultFontSize}rem`;
    this.safeZone.style.marginTop = `${marginY / ScaleManager.defaultFontSize}rem`;
    this.safeZone.style.marginBottom = `${marginY / ScaleManager.defaultFontSize}rem`;
    this.safeZone.style.height = `${ScaleManager.safeZone.height / uiScaleRelativeToCanvasScale / ScaleManager.defaultFontSize}rem`;

    window.OPWrapperService.ScaleManager.makeScalingHTMLElement({
      HTMLElement: this.root,
      relativeScale: uiScale,
      defaultWidth: this._scaleData.innerWidth / uiScale,
      defaultHeight: this._scaleData.innerHeight / uiScale
    })
  }
}
